<div #transferOwnershipConfirmationModal class="modal fade" data-backdrop="static">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content border-radius-0">
      <div class="modal-header text-uppercase py-2 font-size-16">
        <div class="modal-title">
          <ng-content select="[title]"></ng-content>
        </div>
        <button type="button" class="close" (click)="onDecline()">&times;</button>
      </div>
      <div class="modal-body">
        <ng-content select="[body]"></ng-content>
      </div>
      <div class="modal-footer pt-1 border-0">
        <button type="button" appDisableMultipleClick (click)="onDecline()" [ngClass]="{'opacity-6 pointer-events-none': isLoading}" class="btn btn-light btn-lg text-uppercase border-rounded font-weight-normal mx-2" i18n="@@app.no">No</button>
        <button type="button" appDisableMultipleClick class="btn btn-primary btn-lg text-uppercase border-rounded font-weight-normal mx-2"
                [ngClass]="{'opacity-6 pointer-events-none': isLoading}"
                (click)="onConfirm()" i18n="@@app.yes">Yes</button>
      </div>
    </div>
  </div>
</div>
